angular.module('app', ['ngFileUpload', 'ngFlash', 'ngLocale']);

angular.module("app").run(function ($rootScope, $window, ShoppingCartService) {
});

angular.module('app').config(function () {

});
